import Swiper from 'swiper';
import { Navigation, A11y, Keyboard } from 'swiper/modules';

// Rotating hero. The partial only emits [data-hero-slider] when there are 2+
// slides, so no guard for the single-slide case is needed here.
export function initHeroSlider() {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Off-screen slides keep their CTA out of the tab order.
  const syncInert = (swiper) => {
    swiper.slides.forEach((slide, index) => {
      slide.inert = index !== swiper.activeIndex;
    });
  };

  document.querySelectorAll('[data-hero-slider]').forEach((root) => {
    const prev = root.querySelector('[data-hero-prev]');
    const next = root.querySelector('[data-hero-next]');

    new Swiper(root, {
      modules: [Navigation, A11y, Keyboard],
      // rewind (not loop) so there are no cloned slides — the first slide
      // carries the page <h1> and must stay unique in the DOM.
      rewind: true,
      slidesPerView: 1,
      speed: reducedMotion ? 0 : 2000,
      keyboard: { enabled: true },
      navigation: { prevEl: prev, nextEl: next },
      // A11y would otherwise replace the translated button labels with its
      // English defaults.
      a11y: {
        prevSlideMessage: prev.getAttribute('aria-label'),
        nextSlideMessage: next.getAttribute('aria-label'),
      },
      on: { init: syncInert, slideChange: syncInert },
    });
  });
}
